import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M17.5 8.5h-11v-2h11v2zm0 4.5h-11v-2h11v2zm-11 4.5h11v-2h-11v2z" }));
export default createSvgIcon(iconPath, "DragOutline");
//# sourceMappingURL=DragOutlineIcon.js.map